import React, { useState, useEffect } from "react";
import HeroImg from "../../img/HeroImg.png";
import About from "../../img/About.png";
import "../../dist.css/Homepage.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import mealsData from "../../data/meals.json";
import { createClient } from "@supabase/supabase-js";

// Supabase bağlantısını oluşturuyoruz
const supabase = createClient(
  "https://qlgwpthiwclfbgzzjmjw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZ3dwdGhpd2NsZmJnenpqbWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2MDUzOTIsImV4cCI6MjA0MDE4MTM5Mn0.N9-IULDnpuUWR_PNXvXyzdTTIMRsxRAxVGrAagaJn4k"
);

const Homepage = () => {
  const [newsData, setNewsData] = useState([]); // Haber verilerini tutacak state
  const [loading, setLoading] = useState(true); // Yükleme durumu
  const [error, setError] = useState(null); // Hata durumu

  // Haber verilerini çekme fonksiyonu
  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      const { data, error } = await supabase.from("news").select("*").limit(3); // Yalnızca 3 haber çekiyoruz

      if (error) {
        setError(error.message);
      } else {
        setNewsData(data); // Haberleri state'e kaydediyoruz
      }
      setLoading(false);
    };

    fetchNews();
  }, []);

  // Yükleme ve hata durumları için kontroller
  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (error) {
    return <div>Hata: {error}</div>;
  }

  if (!newsData || newsData.length === 0) {
    return <div>Haber bulunamadı.</div>;
  }

  // JSON'dan verileri al
  const featuredMeals = mealsData.meals.slice(0, 3); // İlk 3 yemeği seç

  return (
    <>
      <div className="homepage__container">
        <div className="left__container">
          <motion.h1
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5, type: "spring" }}
          >
            Aradığınız Yemek Tarifi!
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.6, type: "spring" }}
          >
            Yemek Günlüğü ile yemek tarifi aramak artık çok kolay! İyi bir akşam
            yemeğinden sonra insan herkesi, hatta kendi akrabalarını bile
            affedebilir.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 1,
              delay: 0.6,
              type: "spring",
              ease: "easeOut",
            }}
          >
            <div className="left__buttons">
              <Link to="/find" className="find__btn btn">
                Tarifi Bul
              </Link>
              {/* <Link
                to={`/random/${randomMeal.idMeal}`}
                className="random__btn btn"
              >
                <i className="bx bxs-dice-5 bx-tada bx-rotate-90"></i>Şaşırt
                Beni!
              </Link> */}
            </div>
          </motion.div>
        </div>

        <div className="right__container">
          <motion.img
            initial={{ opacity: 0, y: 50 }}
            animate={{ scale: 1.1, opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6, type: "spring" }}
            src={HeroImg}
            alt="HeroImage"
          />
        </div>
      </div>

      <motion.div
        className="featured__section"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{
          duration: 1,
          delay: 1.6,
          ease: "easeOut",
          type: "spring",
          stiffness: "200",
        }}
      >
        <h1>Öne Çıkan Yemekler</h1>
        <p>En iyi yemeklerimizin tümü tek bir leziz çırpıda!</p>

        <motion.div
          className="featured__container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, delay: 1, ease: "easeOut" }}
        >
          {featuredMeals.map((meal) => (
            <div className="featured__meal" key={meal.idMeal}>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 1,
                  delay: 1,
                  ease: "easeOut",
                  type: "spring",
                  stiffness: "200",
                }}
              >
                <Link to={`/meal/${meal.idMeal}`} className="meal__item">
                  <img src={meal.strMealThumb} alt={meal.strMeal} />
                  <div className="meal__lowered">
                    <h3>{meal.strMeal}</h3>
                    <p>
                      <i className="bx bx-map-alt"></i>
                      {meal.strArea}
                    </p>
                  </div>
                </Link>
              </motion.div>
            </div>
          ))}
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{
          duration: 1,
          delay: 2.1,
          ease: "easeOut",
          type: "spring",
          stiffness: "200",
        }}
      >
        <div className="about__section">
          <div className="about__left">
            <h1>Hakkımızda</h1>
            <p>
              Yemek Günlüğü, yemek tarifi aramanıza ve sizin için en iyi yemek
              tarifini bulmanıza olanak tanıyan bir yemek tarifi web sitesidir.
              Bir yemek tarifini ara, kategoriye veya malzemeye göre
              arayabilirsiniz. Ayrıca rastgele bir yemek tarifi de
              arayabilirsiniz. Burada sizin için en iyi yemek tariflerinden
              birini bulabilirsiniz.
            </p>
          </div>
          <div className="img__container">
            <img src={About} alt="about" />
          </div>
        </div>
      </motion.div>

      {/* Haberler */}
      <motion.div
        className="news__section"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{
          duration: 1,
          delay: 2.5,
          ease: "easeOut",
          type: "spring",
        }} // Delay arttırıldı
      >
        <motion.h1
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 2.5, type: "spring" }} // Delay arttırıldı
          className="news__heading"
        >
          Haberler
        </motion.h1>
        <p>Sizlere özel en taze haberler!</p>

        <motion.div
          className="news__container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, delay: 2.5, ease: "easeOut" }} // Delay arttırıldı
        >
          {newsData.map((news) => (
            <div className="news__item" key={news.news_id}>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 1,
                  delay: 2.5, // Delay arttırıldı
                  ease: "easeOut",
                  type: "spring",
                  stiffness: 200,
                }}
              >
                <Link to={`/news/${news.news_id}`} className="news__link">
                  <img
                    src={news.news_img}
                    alt={news.news_title}
                    className="news__image"
                  />
                  <div className="news__lowered">
                    <h3>{news.news_title}</h3>
                    {/* 'dangerouslySetInnerHTML' kullanarak HTML etiketlerini işliyoruz */}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: news.news_content.slice(0, 100),
                      }}
                    />
                  </div>
                </Link>
              </motion.div>
            </div>
          ))}
        </motion.div>
      </motion.div>
      {/* Haberler */}
    </>
  );
};

export default Homepage;
